// Fashion & Beauty V1: Super Admin department enablement (enable-only; Owner archives from the store side).
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export function SaDepartmentsCard({ clientId, industryKey }) {
  const [view, setView] = useState(null);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState("");
  const load = () => api.get(`/superadmin/clients/${clientId}/departments`).then((r) => setView(r.data)).catch(() => setView(null));
  useEffect(() => { if (clientId) load(); }, [clientId, industryKey]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!view || !view.is_fashion) return null;
  const enable = async (key) => {
    setBusy(key);
    try { await api.put(`/superadmin/clients/${clientId}/departments/${key}`, { enabled: true, reason }); toast.success("Department enabled"); setReason(""); load(); }
    catch (e) { const d = e.response?.data?.detail; toast.error(typeof d === "string" ? d : d?.message || "Could not enable department"); }
    finally { setBusy(""); }
  };
  return (
    <div className="rounded-xl border border-border p-3 mb-3 space-y-2" data-testid="sa-departments-card">
      <p className="text-xs uppercase tracking-wider text-muted-foreground">Fashion & Beauty Departments</p>
      <p className="text-xs text-muted-foreground">Enabling is permanent — stores cannot toggle departments. The Owner may archive one from the operational view (products and history kept) and restore it later.</p>
      <Input placeholder="Reason (optional, applied to the next enable)" value={reason} onChange={(e) => setReason(e.target.value)} className="h-8 text-xs" data-testid="sa-dept-reason" />
      <div className="space-y-1.5">
        {view.departments.map((d) => (
          <div key={d.key} className="flex items-center justify-between gap-2 text-sm" data-testid={`sa-dept-row-${d.key}`}>
            <span className="font-medium">{d.name}</span>
            <span className="flex items-center gap-2">
              {d.enabled
                ? <Badge variant="outline" className={d.archived ? "text-amber-600 border-amber-500/40" : "text-emerald-600 border-emerald-500/40"} data-testid={`sa-dept-state-${d.key}`}>{d.archived ? "Enabled · archived by store" : "Enabled"}</Badge>
                : <Button size="sm" variant="outline" className="h-7" disabled={busy === d.key} onClick={() => enable(d.key)} data-testid={`sa-dept-enable-${d.key}`}>Enable</Button>}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
